import Vue from 'vue';
import { getApiUrl } from '@/shared/utils/helpers';
export async function createSearch(params) {
    return Vue.axios.post(`${getApiUrl('v4')}/search/create`, params);
}
